import React from 'react';

import { Typography } from '@mui/material';

import RelatedTile from '../RelatedTile';

import ContactMethodLink from './ContactMethodLink';
import type { AccountContact } from './types';

interface Props {
  contact: AccountContact;
}

export default function AccountContactTile({ contact }: Props) {
  const fields = [
    { label: 'Title', value: contact.title },
    { label: 'Email', value: <ContactMethodLink kind="email" value={contact.email} /> },
    { label: 'Mobile', value: contact.mobilePhone },
  ];

  return (
    <RelatedTile
      fields={fields}
      heading={
        <Typography variant="subtitle1" component="h3">
          {contact.name}
        </Typography>
      }
    />
  );
}
